import React, { useState, useEffect } from 'react';
import Splash from './Splash';
import Carousel from '../../Components/Carousel';
import { useNavigate } from 'react-router';
import { useParams } from 'react-router-dom';
import Button from '../../Components/Button';
import InformationTable from './InformationTable';
import { ConvertToPounds } from '../../Components/Functions';
import {
    CarouselImagesType,
    ConfigurationImagesType,
    SingleVehicleType,
    SingleVehicleImagesType,
} from '../../Components/Types';
import ReactGA from 'react-ga4';
import Loader from 'Components/Loader';
import { VehicleAPI } from 'API/VehicleAPI';
import { useMsal } from '@azure/msal-react';
import {
    Content,
    ContentContainer,
    Header,
    InformationBlock,
    InfoHeader,
    Price,
    SummaryBlock,
} from './MotorhomePageComponents';

type VehicleImagesType = {
    carouselImgs: CarouselImagesType[];
    configImgs: ConfigurationImagesType[];
};

function MotorhomesPage() {
    const { mhid, mhname } = useParams<{ mhid: string; mhname: string }>();
    const [loading, setLoading] = useState(true);
    const [vehicleImages, setVehicleImages] = useState<VehicleImagesType>(
        {} as VehicleImagesType
    );
    const [vehicle, setVehicle] = useState<SingleVehicleType>(
        {} as SingleVehicleType
    );
    const navigate = useNavigate();
    const vehicle_id = parseInt(mhid ? mhid : '');
    const { instance } = useMsal();

    ReactGA.send({ hitType: 'pageview', page: window.location.pathname });

    useEffect(() => {
        if (!vehicle_id) {
            navigate('/');
        }
        const getVehicleData = async () => {
            const motorhome: SingleVehicleType = await VehicleAPI.GetVehicle(
                instance,
                vehicle_id
            );
            setVehicle(motorhome);
            updateVehicleImages(motorhome);
        };
        getVehicleData();
        setLoading(false);
    }, [instance, navigate, vehicle_id]);

    const updateVehicleImages = (singleVehicle: SingleVehicleType) => {
        const carouselImagesList: CarouselImagesType[] = [];
        const configImagesList: ConfigurationImagesType[] = [];

        singleVehicle.images.forEach(
            (img: SingleVehicleImagesType, i: number) => {
                const id = i + 1;

                if (img.typedesc === 'Arial') {
                    const image = {
                        id,
                        url: `/images/vehicles/${img.filename}`,
                        alt: singleVehicle.name,
                    };
                    configImagesList.push(image);
                } else {
                    const image = {
                        id,
                        url: `/images/vehicles/${img.filename}`,
                        visible: i === 1,
                        alt: singleVehicle.name,
                    };
                    carouselImagesList.push(image);
                }
            }
        );
        setVehicleImages({
            carouselImgs: carouselImagesList,
            configImgs: configImagesList,
        });
    };

    const checkAvailability = () => {
        const startDate = '';
        const endDate = '';
        var data = {
            vehicle_id: vehicle_id,
            start_date: startDate,
            end_date: endDate,
        };
        navigate(
            `/CheckAvailability/${data.vehicle_id}/${mhname?.replaceAll(
                ' ',
                ''
            )}`
        );
    };

    return (
        <>
            <Splash vehicle={vehicle} />
            <ContentContainer>
                <Content>
                    <Header>Specifications</Header>
                    {loading ? (
                        <Loader />
                    ) : (
                        <>
                            {loading ? (
                                <Loader />
                            ) : (
                                <>
                                    <InformationBlock>
                                        <Carousel
                                            imagesList={
                                                vehicleImages.carouselImgs
                                            }
                                            slideshow={
                                                vehicleImages.carouselImgs
                                                    ?.length > 1
                                                    ? true
                                                    : false
                                            }
                                        />
                                        <SummaryBlock>
                                            <InfoHeader>
                                                {vehicle.name}
                                            </InfoHeader>
                                            <p>Prices start from</p>
                                            <p>
                                                <Price>
                                                    {ConvertToPounds(
                                                        vehicle.baseprice
                                                    )}
                                                </Price>{' '}
                                                per day
                                            </p>
                                            <Button
                                                type="button"
                                                colour="dark"
                                                text="check availability"
                                                onClick={() =>
                                                    checkAvailability()
                                                }
                                            />
                                        </SummaryBlock>
                                    </InformationBlock>
                                    <InformationTable
                                        vehicle={vehicle}
                                        imagesList={vehicleImages?.configImgs}
                                    />
                                </>
                            )}
                        </>
                    )}
                </Content>
            </ContentContainer>
        </>
    );
}
export default MotorhomesPage;
